import { queryOptions, useQuery } from '@tanstack/react-query';
import { operations, SchemaTradeDto } from '../generated/apiTypes';
import { dataOrThrow, fetchClient } from '../lib/apiClient';
import { Gwei } from '../lib/gwei';
import { PrettyMerge } from '../lib/tsUtilityTypes';

const transformTrade = (trade: SchemaTradeDto) => ({
  ...trade,
  makerFeeUsd: Gwei.toGwei(trade.makerFeeUsd),
  takerFeeUsd: Gwei.toGwei(trade.takerFeeUsd),
  price: Gwei.toGwei(trade.price),
  filled: Gwei.toGwei(trade.filled),
});

export type Trade = ReturnType<typeof transformTrade>;
type TradeParams = PrettyMerge<
  { productId: string | undefined },
  operations['OrderController_listTrades']['parameters']['query']
>;
export const tradesQuery = ({ productId, limit }: TradeParams) => {
  return queryOptions({
    queryKey: ['GET', '/v1/order/trade', productId, limit] as const,
    queryFn: async ({ queryKey, signal }) => {
      const [method, url] = queryKey;
      const { data } = await fetchClient[method](url, {
        signal,
        params: {
          query: {
            productId,
            limit,
          },
        },
      }).then(dataOrThrow);
      return data?.data.map(transformTrade) ?? null;
    },
    enabled: Boolean(productId),
  });
};

export const useTrades = (params: TradeParams) => useQuery(tradesQuery(params));
